import React from 'react';

import { TimezoneLanguageDialogStep } from './Steps/TimezoneLanguageDialogStep/TimezoneLanguageDialogStep';
import { TrainingLevelDialogStep } from './Steps/TrainingLevelDialogStep/TrainingLevelDialogStep';
import { PendingQuestionnairesDialogStep } from './Steps/PendingQuestionnairesDialogStep';
import { HealthIssuesDialogStep } from './Steps/HealthIssuesDialogStep/HealthIssuesDialogStep';
import { FitnessGoalsDialogStep } from './Steps/FitnessGoalsDialogStep/FitnessGoalsDialogStep';
import { BasicInfoDialogStep } from './Steps/BasicInfoDialogStep/BasicInfoDialogStep';
import { AboutDialogStep } from './Steps/AboutDialogStep/AboutDialogStep';
import { ClientOnboardingSteps } from './clientOnboarding.steps';
import { Wizard } from '../../../allFeatures';

type ClientOnboardingDialogContextType = {
  onFinish?: () => void;
};

const ClientOnboardingDialogContext =
  React.createContext<ClientOnboardingDialogContextType>({});

export function useClientOnboardingDialogContext() {
  return React.useContext(ClientOnboardingDialogContext);
}

export interface ClientOnboardingDialogProps {
  onFinish?: () => void;
}

const ClientOnboardingDialog = ({ onFinish }: ClientOnboardingDialogProps) => {
  return (
    <ClientOnboardingDialogContext.Provider value={{ onFinish }}>
      <Wizard steps={ClientOnboardingSteps}>
        <TimezoneLanguageDialogStep />
        <BasicInfoDialogStep />
        <AboutDialogStep />
        <TrainingLevelDialogStep />
        <FitnessGoalsDialogStep />
        <HealthIssuesDialogStep />
        <PendingQuestionnairesDialogStep />
      </Wizard>
    </ClientOnboardingDialogContext.Provider>
  );
};

export default ClientOnboardingDialog;
